module.exports = {
    customer: 'sula',
    assets: { logo: 'logo.svg' }
    
};